import React, {useEffect} from 'react';
import Head from "next/head";
import Link from "next/link";

const FtsPage = (props) => {
    const ual = props['ual'] ? props['ual'] : {'activeUser': null};

    const activeUser = ual['activeUser'];

    const userName = activeUser ? activeUser['accountName'] : null;

    useEffect(() => {
    }, [userName]);

    const image = 'https://www.nfthive.io/nfthive-logo.png';

    return (
        <div className={"Page"} id="ImprintPage">
            <Head>
                <meta id="og-title" property="og:title" content={'Hive Block Producer'} />
                <meta id="og-description" property="og:description" content={'Hive Block Producer - Home'} />
                <meta id="og-image" property="og:image" content={image} />
                <meta id="twitter-image" property="twitter:image" content={image} />
                <meta name="msapplication-TileColor" content="#F6C30D" />
                <meta name="theme-color" content="#1A1A1A"  />
                <link id='page-image' rel="apple-touch-icon" href={image} />
                <meta id="twitter-title" property="twitter:title" content={'Hive Block Producer'}  />
                <meta id="twitter-description" property="twitter:description" content={'Hive Block Producer - Home'} />
            </Head>
            <div className="AccountDetails">
                <div className="ProjectContent">
                    <h1 className={"ProjectHeader"}>NFTHive.io</h1>
                    <Link href={'https://nfthive.io'}>
                        <div className={"NextLink"}>
                            <img src={'/nfthive.png'} alt={'nfthive'} />
                        </div>
                    </Link>
                    <div className={"WhiteText"}>
                        <br/>
                        NFTHive is our WAX Community Site and Marketplace. Its features include:<br/><br/>
                        <li>A Marketplace showing listings from various smart contracts such as atomicmarket, simplemarket, waxstash, myth.market, waxarena, waxinvetory, etc</li>
                        <li>Showing full Sets of over 100 collections and enabling users to complete sets</li>
                        <li>Bulk Operations for NFTs (Mass selling, buying, transferring, burning and more)</li>
                        <li>On site analytics, including Credit Card Sales, Drop Sales and Secondary Market Sales of various markets</li>
                    </div>
                </div>
                <div className="ProjectContent">
                    <h1 className={"ProjectHeader"}>WAXMarketCap</h1>
                    <Link href={'https://waxmarketcap.com'}>
                        <div className={"NextLink"}>
                            <img src={'/waxmarketcap_banner.png'} alt={'wmc'} />
                        </div>
                    </Link>
                        <div className={"WhiteText"}>
                            <br/>
                            WAXMarketCap is a standalone analytics site for the WAX blockchain, focussing on NFT Sales on Secondary Markets, Primary and Drop Sales:
                        </div>
                </div>
                <div className="ProjectContent">
                    <h1 className={"ProjectHeader"}>WAX Market Template</h1>
                    <Link href={'https://waxdummymarket.com'}>
                        <div className={"NextLink"}>
                            <img src={'/waxdummy.png'} alt={'waxdummy'} />
                        </div>
                    </Link>
                        <div className={"WhiteText"}>
                            <br/>
                            The Market Template is an open Source market using the atomicmarket contract and public APIs. It includes:
                            <li>Market Listings & Bundles</li>
                            <li>Auctions</li>
                            <li>Drops</li>
                            <li>User Inventory</li>
                            <li>Pack Openings</li><br/>
                        </div>
                    The Github Repository can be found here: <a href={'https://github.com/hivebp/wax-market-template'}>WAX Market Template</a>
                </div>
            </div>
        </div>
    );
};

export default FtsPage;
